import type { ThemeDefaultParams } from 'ag-grid-community';
import { FINDINGS_GROUP_HEADER_ROW_CLASS } from '@terra/ui-design-system';
import { css, token } from '@terra/ui-styled-system';

export const LIST_PAGE_TABLE_HEADER_HEIGHT_PX = 44;

export const LIST_PAGE_TABLE_THEME_PARAMS: Partial<ThemeDefaultParams> = {
  backgroundColor: token('colors.bg.canvas'),
  cellHorizontalPadding: 12,
  headerFontWeight: 500,
  headerBackgroundColor: 'transparent',
  headerTextColor: token('colors.fg.neutral.subtle'),
  headerColumnResizeHandleHeight: 16,
  headerColumnResizeHandleWidth: 1,
  headerColumnResizeHandleColor: token('colors.border.neutral.default'),
  headerRowBorder: { color: token('colors.border.neutral.subtle') },
  rowBorder: { color: token('colors.border.neutral.subtle') },
  pinnedColumnBorder: false,
};

export const LIST_PAGE_TABLE_HEADER_CSS = {
  '& .ag-header-cell:not([col-id="select"])': {
    paddingLeft: '8px',
  },
} as const;

export const LIST_PAGE_GROUP_HEADER_ROW_CLASS = 'list-page-group-header-row';

export const ASSETS_TABLE_GROUP_HEADER_ROW_CLASS = 'assets-group-header-row';

type GroupHeaderStickyBackground = 'bg.canvas' | 'bg.subtle';

type GroupHeaderStickyRowClass =
  | typeof LIST_PAGE_GROUP_HEADER_ROW_CLASS
  | typeof FINDINGS_GROUP_HEADER_ROW_CLASS
  | typeof ASSETS_TABLE_GROUP_HEADER_ROW_CLASS;

export const listPageGroupHeaderStickyClassName = css({
  [`& .${LIST_PAGE_GROUP_HEADER_ROW_CLASS} .ag-cell`]: {
    backgroundColor: 'bg.canvas',
    position: 'sticky',
    left: '0',
    zIndex: 1,
  },
});

const findingsGroupHeaderStickyClassName = css({
  [`& .${FINDINGS_GROUP_HEADER_ROW_CLASS} .ag-cell`]: {
    backgroundColor: 'bg.subtle',
    position: 'sticky',
    left: '0',
    zIndex: 1,
  },
});

const assetsGroupHeaderStickyClassName = css({
  [`& .${ASSETS_TABLE_GROUP_HEADER_ROW_CLASS} .ag-cell`]: {
    backgroundColor: 'bg.canvas',
    position: 'sticky',
    left: '0',
    zIndex: 1,
  },
});

export const createGroupHeaderStickyClassName = ({
  rowClass,
  backgroundColor,
}: {
  rowClass: GroupHeaderStickyRowClass;
  backgroundColor: GroupHeaderStickyBackground;
}) => {
  if (
    rowClass === FINDINGS_GROUP_HEADER_ROW_CLASS &&
    backgroundColor === 'bg.subtle'
  ) {
    return findingsGroupHeaderStickyClassName;
  }

  if (rowClass === ASSETS_TABLE_GROUP_HEADER_ROW_CLASS) {
    return assetsGroupHeaderStickyClassName;
  }

  return listPageGroupHeaderStickyClassName;
};
